import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { EmpresaModel } from '../models/empresa-model';
import { Funcoes, Periodos } from '../services/funcoes';
import { Services } from '../services/servicos';
import { VistoriaModel } from './vistoria-model';

@Component({
  selector: 'app-comercial',
  templateUrl: './vistoria.component.html',
  styleUrls: ['./vistoria.component.css']
})
export class VistoriaComponent implements OnInit {
//DECLARAÇÕES
funcoes: Funcoes = new Funcoes();
//
//INI VARIÁVES
empresas: EmpresaModel[];
selecionarEmpresa: EmpresaModel;

periodos: Periodos[];
selecionarPeriodo: string;

data_inicial: Date = new Date();
data_final: Date = new Date();
grafico: any;
grafico_bar: any;

lista: VistoriaModel[];
currentUser = JSON.parse(localStorage.getItem('currentUser'));
total: number
loading: boolean = true;
filtros: VistoriaModel = new VistoriaModel();

//A - Total vistoria
listaGeral: VistoriaModel[];
listaTotalVistoria: VistoriaModel[];
totalTotalVistoria: number
displayTotalVistoria: boolean;
//B - Vistoria aprovados
listaVistoriaAprovados: VistoriaModel[];
totalVistoriaAprovados: number
displayVistoriaAprovados: boolean;
//C - Vistoria em negociação	
listaVistoriaNegociacao: VistoriaModel[];
totalVistoriaNegociacao: number
displayVistoriaNegociacao: boolean;
//D - Vistoria em negociação	
listaVistoriaNegociacaoGeral: VistoriaModel[];
totalVistoriaNegociacaoGeral: number
displayVistoriaNegociacaoGeral: boolean;
//E - Vistoria perdidos
listaVistoriaPerdidos: VistoriaModel[];
totalVistoriaPerdidos: number
displayVistoriaPerdidos: boolean;
//E - Vistoria Ortobras
listaVistoriaOrtobras: VistoriaModel[];
totalVistoriaOrtobras: number
displayVistoriaOrtobras: boolean;
//G - Vistoria Espel
listaVistoriaEspel: VistoriaModel[];
totalVistoriaEspel: number
displayVistoriaEspel: boolean;
//FIM VARIÁVEIS


constructor(private service: Services,
  private messageService: MessageService,
  private confirmationService: ConfirmationService,
  private config: PrimeNGConfig) {

  this.periodos = this.funcoes.Periodos;
  if (this.periodos.length > 0) {
    this.selecionaMesAtual();
  }
  //this.origens = this.funcoes.Origens;
}

selecionaMesAtual() {
  var today = new Date();
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  this.selecionarPeriodo = this.periodos.find(c => c.cod == mm).nome;
  console.log(this.selecionarPeriodo);
  this.selecionaPeriodo(this.selecionarPeriodo);
}

ngOnInit(): void {

  this.config.setTranslation({
    accept: 'Aceitar',
    reject: 'Cancelar',
    dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
    monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    today: 'Hoje',
    clear: 'Limpar'
    //translations
  });

  //BUSCANDO EMPRESAS
  try {
    this.service.listarEmpresas()
      .subscribe(data => {
        if (data.Success) {
          this.empresas = data.Response;
        }
      },
        err => console.error(err)
      );
  }
  catch (e) {
    alert(e);
  }
  //BUSCANDO EMPRESAS     
    

  this.selecionaMesAtual();
  //PESQUISANDO AO ABRIR
  this.pesquisar();
}

pesquisar() {
  this.loading = true;

  this.filtros.filtro_data_inicial = this.data_inicial;
  this.filtros.filtro_data_final = this.data_final;
  this.filtros.coligada = this.selecionarEmpresa == null ? "" : this.selecionarEmpresa.nome_fantasia;

  try {
    this.service.listarVistoria(this.filtros)
      .subscribe(data => {
        if (data.Success) {
          this.lista = data.Response;
          this.total = this.lista.length;
          this.loading = false;
           this.updateChart(data.Response);
          
        }
      },
        err => console.error(err)
      );
  }
  catch (e) {
    alert(e);
  }
}

onRowSelect(event) {

  try {
    this.service.listarVistoriaOrigem(this.filtros)
      .subscribe(data => {
        if (data.Success) {
          this.listaGeral = data.Response;
          var today = new Date();
          if (event.data.descricaoTitulo == "A - Total Vistorias") {
              this.displayTotalVistoria = true;
              this.listaTotalVistoria = this.listaGeral;
              this.totalTotalVistoria= this.listaTotalVistoria.length;
            }
            else if (event.data.descricaoTitulo == "B - Vistorias aprovadas") {
              this.displayVistoriaAprovados = true;
              this.listaVistoriaAprovados = this.listaGeral.filter(c => c.situacao == "Aprovada" && new Date(c.data_fechamento) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data_fechamento) < today);
              this.totalVistoriaAprovados = this.listaVistoriaAprovados.length;
            }
            else if (event.data.descricaoTitulo == "C - Vistorias em negociação") {
              this.displayVistoriaNegociacao = true;
              this.listaVistoriaNegociacao  = this.listaGeral.filter(c => c.situacao == "Negociação" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalVistoriaNegociacao  = this.listaVistoriaNegociacao.length;
            }
            else if (event.data.descricaoTitulo == "D - Vistorias em negociação geral") {
              this.displayVistoriaNegociacao = true;
              this.listaVistoriaNegociacao  = this.listaGeral.filter(c => c.situacao == "Negociação" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalVistoriaNegociacao  = this.listaVistoriaNegociacao.length;
            }
            else if (event.data.descricaoTitulo == "E - Vistorias perdidas") {
              this.displayVistoriaPerdidos = true;
              this.listaVistoriaPerdidos  = this.listaGeral.filter(c => c.situacao == "Perdida" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalVistoriaPerdidos  = this.listaVistoriaPerdidos.length;
            }          
            else if (event.data.descricaoTitulo == "F - Vistorias ortobrás") {
              this.displayVistoriaOrtobras = true;
              this.listaVistoriaOrtobras  = this.listaGeral.filter(c => c.situacao == "Aprovada" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalVistoriaOrtobras  = this.listaVistoriaOrtobras.length;
            }          
            else if (event.data.descricaoTitulo == "G - Vistorias espel") {
              this.displayVistoriaEspel = true;
              this.listaVistoriaEspel  = this.listaGeral.filter(c => c.situacao == "Aprovada" && new Date(c.data) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data) < today);
              this.totalVistoriaEspel  = this.listaVistoriaEspel.length;
            }          
        }
      },
        err => console.error(err)
      );
  }
  catch (e) {
    alert(e);
  }
}

comparandoDatasTitulosVencer(vencimento: Date) {
  var today = new Date();
  var DataVencimento = new Date(vencimento);
  console.log(DataVencimento);
  console.log(today);

  return (DataVencimento > today);
}

updateChart(chart: VistoriaModel[]) {

  this.grafico = {
    labels: [
      'B - Vistorias aprovadas',
      'C - Vistorias em negociação',
      'D - Vistorias em negociação geral',
      'E - Vistorias perdidos'],
    datasets: [
      {
        data: [chart[1].total_dinheiro, chart[2].total_dinheiro, chart[3].total_dinheiro, chart[4].total_dinheiro],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFFF00",
          "#b01ea9",
        ],
        hoverBackgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFFF00",
          "#b01ea9",
        ]
      }]
  };
}

onChangePeriodo(event) {
  if (event.value != null) {
    this.selecionaPeriodo(event.value);
    console.log(event);
  }
}

selecionaPeriodo(mes: string) {
  console.log('LOKOOOOO' + mes);
  if (mes == "Todos") {
    this.data_inicial = new Date(1950, 1, 1);
    this.data_final = new Date();
  }
  else if (mes == "3 Meses") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 111));
    this.data_final = new Date();
    console.log((today.getDay() - 90));
    console.log(today);
    console.log(this.data_inicial);
  }
  else if (mes == "6 Meses") {

    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 201));
    this.data_final = new Date();
    console.log((today.getDay() - 180));
    console.log(today);
    console.log(this.data_inicial);
  }
  else if (mes == "9 Meses") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 291));
    this.data_final = new Date();
    console.log((today.getDay() - 270));
    console.log(today);
    console.log(this.data_inicial);
  }
  else if (mes == "1 Ano") {

    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 386));
    this.data_final = new Date();
    console.log((today.getDay() - 365));
    console.log(today);
    console.log(this.data_inicial);
  }
  else if (mes == "Janeiro") {

    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 0, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Fevereiro") {

    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 1, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Março") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 2, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Abril") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 3, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Maio") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 4, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Junho") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 5, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Julho") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 6, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Agosto") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 7, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Setembro") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 8, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Outubro") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 9, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Novembro") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 10, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
  else if (mes == "Dezembro") {
    var today = new Date();
    this.data_inicial = new Date(today.getFullYear(), 11, 1);
    var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
    this.data_final = ultimoDia;
    console.log(ultimoDia.getDate());
  }
}

}
